/**
 * Created by frank.law on 11/13/17.
 */
export const REQUEST_BEGIN = 'REQUEST_BEGIN';
export const REQUEST_END = 'REQUEST_END';
export const RESPONSE_ERROR = 'RESPONSE_ERROR';
export const INPUT_ERROR = 'INPUT_ERROR';
export const CHALLENGE_SUCCESS = 'CHALLENGE_SUCCESS';

export const UPDATE_APP_LOGO = 'UPDATE_APP_LOGO';
export const UPDATE_RESET_TOKEN = 'UPDATE_RESET_TOKEN';
export const UPDATE_OAUTH_PROPS = 'UPDATE_OAUTH_PROPS';

export const SUBMIT_INIT_CHALLENGE = 'SUBMIT_INIT_CHALLENGE';
export const SUBMIT_USERNAME_CHALLENGE = 'SUBMIT_USERNAME_CHALLENGE';
export const SUBMIT_PASSWORD_CHALLENGE = 'SUBMIT_PASSWORD_CHALLENGE';
export const SUBMIT_TOTP_SETUP_CHALLENGE = 'SUBMIT_TOTP_SETUP_CHALLENGE';
export const SUBMIT_TOTP_VERIFY_CHALLENGE = 'SUBMIT_TOTP_VERIFY_CHALLENGE';
export const SUBMIT_BACKUP_CODES_CHALLENGE = 'SUBMIT_BACKUP_CODES_CHALLENGE';
export const SUBMIT_FORGOT_PASSWORD_CHALLENGE = 'SUBMIT_FORGOT_PASSWORD_CHALLENGE';
export const SUBMIT_RESEND_LINK = 'SUBMIT_RESEND_LINK';
export const SUBMIT_INIT_RESET_CHALLENGE = 'SUBMIT_INIT_RESET_CHALLENGE';
export const SUBMIT_RESET_PASSWORD_CHALLENGE = 'SUBMIT_RESET_PASSWORD_CHALLENGE';
export const SUBMIT_SAML_REQUEST = 'SUBMIT_SAML_REQUEST';
export const SUBMIT_REGION_REDIRECT_REQUEST = 'SUBMIT_REGION_REDIRECT_REQUEST';
export const SUBMIT_STANDARD_LOGIN_REQUEST = 'SUBMIT_STANDARD_LOGIN_REQUEST';
export const SUBMIT_STANDARD_LOGIN_REGION_REDIRECT = 'SUBMIT_STANDARD_LOGIN_REGION_REDIRECT';
export const SUBMIT_INIT_STANDARD_LOGIN_CHALLENGE = 'SUBMIT_INIT_STANDARD_LOGIN_CHALLENGE';
export const SUBMIT_INIT_STANDARD_LOGIN_REQUEST = 'SUBMIT_INIT_STANDARD_LOGIN_REQUEST';
export const SUBMIT_INIT_STANDARD_LOGIN_SENT = 'SUBMIT_INIT_STANDARD_LOGIN_SENT';

export const SHOW_USER_MESSAGE = 'SHOW_USER_MESSAGE';
export const BACK_TO_LOGIN = 'BACK_TO_LOGIN';
export const RESET_FORMS = 'RESET_FORMS';

export const USERNAME_ON_CHANGE = 'USERNAME_ON_CHANGE';
export const PASSWORD_ON_CHANGE = 'PASSWORD_ON_CHANGE';
export const AUTH_CODE_CHANGE = 'AUTH_CODE_CHANGE';
export const NEW_PASSWORD_ON_CHANGE = 'NEW_PASSWORD_ON_CHANGE';
export const CONFIRM_PASSWORD_ON_CHANGE = 'CONFIRM_PASSWORD_ON_CHANGE';

export const REDIRECT_FOR_CODE = 'REDIRECT_FOR_CODE';
export const REDIRECT_FOR_TOKEN = 'REDIRECT_FOR_TOKEN';
export const REDIRECT_TO_URL = 'REDIRECT_TO_URL';


export function requestBegin(requestKey) {
    return {
        type: REQUEST_BEGIN,
        requestKey: requestKey
    };
}

export function requestEnd(requestKey) {
    return {
        type: REQUEST_END,
        requestKey: requestKey
    };
}

export function responseError(error) {
    return {
        type: RESPONSE_ERROR,
        error: error
    }
}

export function inputError(error) {
    return {
        type: INPUT_ERROR,
        error: error
    };
}

export function challengeSuccess(response) {
    return {
        type: CHALLENGE_SUCCESS,
        response: response
    }
}

export function updateAppLogo(appName, appLogo) {
    return {
        type: UPDATE_APP_LOGO,
        appLogo: appLogo,
        appName: appName
    }
}

export function updateResetToken(resetToken) {
    return {
        type: UPDATE_RESET_TOKEN,
        resetToken: resetToken
    };
}

export function updateOAuthProperties(responseType, clientId, redirectURI, clientState, redirect, codeChallenge, codeChallengeMethod, prompt, username) {
    return {
        type: UPDATE_OAUTH_PROPS,
        responseType: responseType,
        clientId: clientId,
        redirectURI: redirectURI,
        clientState: clientState,
        redirect: redirect,
        codeChallenge: codeChallenge,
        codeChallengeMethod: codeChallengeMethod,
        prompt: prompt,
        username: username
    };
}

export function submitInitChallenge(responseType, clientId, redirectURI, clientState, redirect, tenantAlias, tenantName, tenantURL, codeChallenge, codeChallengeMethod, prompt, username) {
    return {
        type: SUBMIT_INIT_CHALLENGE,
        responseType: responseType,
        clientId: clientId,
        redirectURI: redirectURI,
        clientState: clientState,
        redirect: redirect,
        tenantAlias: tenantAlias,
        tenantName: tenantName,
        tenantURL: tenantURL,
        codeChallenge: codeChallenge,
        codeChallengeMethod: codeChallengeMethod,
        prompt: prompt,
        username: username
    };
}

export function submitUsernameChallenge(username, token, challenge) {
    return {
        type: SUBMIT_USERNAME_CHALLENGE,
        username: username,
        token: token,
        challenge: challenge
    };
}

export function submitPasswordChallenge(password, token, challenge) {
    return {
        type: SUBMIT_PASSWORD_CHALLENGE,
        password: password,
        token: token,
        challenge: challenge
    };
}

export function submitTOTPSetupChallenge(token, challenge) {
    return {
        type: SUBMIT_TOTP_SETUP_CHALLENGE,
        token: token,
        challenge: challenge
    };
}

export function submitTOTPVerifyChallenge(authCode, token, challenge) {
    return {
        type: SUBMIT_TOTP_VERIFY_CHALLENGE,
        authCode: authCode,
        token: token,
        challenge: challenge
    };
}

export function submitBackupCodesChallenge(token, challenge) {
    return {
        type: SUBMIT_BACKUP_CODES_CHALLENGE,
        token: token,
        challenge: challenge
    };
}

export function submitForgotPasswordChallenge(token, challenge) {
    return {
        type: SUBMIT_FORGOT_PASSWORD_CHALLENGE,
        token: token,
        challenge: challenge
    };
}

export function submitInitResetChallenge(resetToken) {
    return {
        type: SUBMIT_INIT_RESET_CHALLENGE,
        resetToken: resetToken
    };
}

export function submitResetPasswordChallenge(newPassword, newPasswordConfirmation, token, challenge) {
    return {
        type: SUBMIT_RESET_PASSWORD_CHALLENGE,
        newPassword: newPassword,
        newPasswordConfirmation: newPasswordConfirmation,
        token: token,
        challenge: challenge
    };
}

export function submitResendLink(token, resetToken, challenge) {
  return {
      type: SUBMIT_RESEND_LINK,
      token: token,
      resetToken: resetToken,
      challenge: challenge
  };
}

export function submitStandardLoginRequest(email, codeChallenge, codeChallengeMethod) {
    return {
        type: SUBMIT_STANDARD_LOGIN_REQUEST,
        email: email,
        codeChallenge: codeChallenge,
        codeChallengeMethod: codeChallengeMethod
    };
}

export function submitInitStandardLoginChallenge(magicToken) {
    return {
        type: SUBMIT_INIT_STANDARD_LOGIN_CHALLENGE,
        magicToken: magicToken
    };
}

export function submitInitStandardLoginSent() {
    return {
        type: SUBMIT_INIT_STANDARD_LOGIN_SENT
    };
}

export function submitInitStandardLoginRequest() {
    return {
        type: SUBMIT_INIT_STANDARD_LOGIN_REQUEST
    };
}

export function submitRegionRedirectRequest(redirectEndpoint, username) {
    return {
        type: SUBMIT_REGION_REDIRECT_REQUEST,
        redirectEndpoint: redirectEndpoint,
        username: username
    };
}

export function submitStandardLoginRegionRedirect(redirectUrl, redirectEmail, redirectCodeChallenge, redirectCodeChallengeMethod) {
    return {
        type: SUBMIT_STANDARD_LOGIN_REGION_REDIRECT,
        redirectUrl,
        redirectEmail,
        redirectCodeChallenge,
        redirectCodeChallengeMethod
    };
}

export function submitSamlRequest(ssoEndpoint, authnRequest, relayState, signatureAlgorithm) {
    return {
        type: SUBMIT_SAML_REQUEST,
        ssoEndpoint: ssoEndpoint,
        authnRequest: authnRequest,
        token: relayState,
        signatureAlgorithm: signatureAlgorithm
    };
}

export function showUserMessage(title, message, challenge, iconName) {
    return {
        type: SHOW_USER_MESSAGE,
        title: title,
        message: message,
        challenge: challenge,
        iconName: iconName
    }
}

export function backToLogin() {
    return {
        type: BACK_TO_LOGIN
    };
}

export function resetForms() {
    return {
        type: RESET_FORMS
    };
}


export function usernameOnChange(value) {
    return {
        type: USERNAME_ON_CHANGE,
        newValue: value
    };
}

export function passwordOnChange(value) {
    return {
        type: PASSWORD_ON_CHANGE,
        newValue: value
    };
}

export function authCodeOnChange(value) {
    return {
        type: AUTH_CODE_CHANGE,
        newValue: value
    };
}

export function newPasswordOnChange(value) {
    return {
        type: NEW_PASSWORD_ON_CHANGE,
        newValue: value
    };
}

export function confirmPasswordOnChange(value) {
    return {
        type: CONFIRM_PASSWORD_ON_CHANGE,
        newValue: value
    };
}

export function redirectForCode(targetUrl, state, code, regionName, platform) {
    return {
        type: REDIRECT_FOR_CODE,
        targetUrl: targetUrl,
        state: state,
        code: code,
        regionName: regionName,
        platform: platform
    };
}

export function redirectForToken(targetUrl, state, accessToken, tokenType, regionName, platform) {
    return {
        type: REDIRECT_FOR_TOKEN,
        targetUrl: targetUrl,
        state: state,
        accessToken: accessToken,
        tokenType: tokenType,
        regionName: regionName,
        platform: platform
    };
}

export function redirectToUrl(targetUrl, state, regionName, platform) {
    return {
        type: REDIRECT_TO_URL,
        targetUrl: targetUrl,
        state: state,
        regionName: regionName,
        platform: platform
    };
}
